module.exports = "mutation SaveListOfDrugAnswers{\n  SaveListOfDrugAnswers(mutation:$mutation) {\n    id,\n    recordId,\n    recordType\n  }\n}\n"